import { render, staticRenderFns } from "./modal-extra-package.vue?vue&type=template&id=9f6f9b2c&scoped=true"
import script from "./modal-extra-package.vue?vue&type=script&lang=js"
export * from "./modal-extra-package.vue?vue&type=script&lang=js"
import style0 from "./modal-extra-package.vue?vue&type=style&index=0&id=9f6f9b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6f9b2c",
  null
  
)

export default component.exports